import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import backicon from "../../../../../Assets/icons/backIcon.svg"
import axiosInstance from '../../../../services/api/API';
import { format } from "date-fns";
import { showCustomAlert } from '../../../../customComponents/CustomSweetAlert';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import Loader from '../../../../customComponents/CustomLoader';

const CreatePhysicalStockTaking = () => {

  const [ userTypedd, setUserTypedd ] = useState([])
  const [ vendorName, setVendorName ] = useState([])
  const [validationErrors, setValidationErrors] = useState({});
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const token = localStorage.getItem("authToken");
  const [businesspartner,setBusinessPartner] = useState()

  useEffect(() => {
    userTypedropdown()
  },[])
  useEffect(()=>{
    if(formData?.business_partner_id){
      console.log("businessparter",formData?.business_partner_id);
      
      setBusinessPartner(formData?.business_partner_id)
      vendorNameList()
    }
   
  },[formData?.business_partner_id])
  useEffect(()=>{
    if(userType !== 'superadmin'){
      vendorNameList()
    }
  },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  const vendorNameList = async () => {
    try{
      const response = await axiosInstance.post("/physicalstocktakeitem/ddllogisticbasevendor",{
        business_partner_id: formData?.business_partner_id || businessPartnerId,
        vendor_type_id: 1
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response.data.data?.data
      console.log("vendoroptioins",data);
      
      const vendorNameOptions = data.map(user => ({
        value: user.ID,
        label:user.NAME,
      }))
      setVendorName(vendorNameOptions)
    }catch(error) {
      console.log(error)
    }
  }



  // Add states for table data 
  const [tableData, setTableData] = useState([]); 

  const navigate = useNavigate();

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    console.log("formData",formData);
    try {
    setLoading(true)
    const formattedDOB=format(formData.trn_date,"yyy-MM-dd")
    const formatJD = format(formData.ref_date,"yyy-MM-dd")

    const payload = {
    // trn_no,
    vendor_id:formData.vendor_id,
    trn_date: formattedDOB,
    ref_no: formData.ref_no,
    ref_date: formatJD,
    // trn_total, 
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post('/physicalstocktake/create', payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      }
    );
  
      console.log("Unit added successfully:", response.data);
 

      showCustomAlert({
        title: "Success",
        text:"Are you sure you want to create a record in Physical Stock Taking.",
        confirmButtonText: "Physical stock taking created successfully.",
        icon: "success",
        confirmButtonText: "OK",
        callback: () => {
          navigate('/logistics/manage-stock/physical-stock-taking');
        },
      });
      
    } catch (error) {
      console.error('Error adding data:', error);

      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
    console.log("clicked")
  };

  const CustomerInputs = [
    ...(userType === "superadmin"
        ? [
            {
              name: "business_partner_id",
              label: "Business Partner",
              type: "dropdown",
              required: true,
              options: userTypedd,
              gridClass: "col-lg-4",
              validation: {
                required: true,
                pattern: /^[A-Za-z0-9 ]*$/,
                message: "Only alphabets and digits are allowed",
              },
            },
          ]
        : []),
  {
    name: "vendor_id",
    label: "Vendor Name",
    type: "dropdown",
    options: vendorName,
    required: true,
    validation:{required:true},
    gridClass: "col-lg-4",
  },
//   {
//     name: "trn_no",
//     label: "Transaction No.",
//     type: "number",
//     required: true,
//     gridClass: "col-lg-4",
//   },
  {
    name: "trn_date",
    label: "Transaction Date",
    type: "date",
    validation:{required:true},
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "ref_no",
    label: "Reference No.",
    placeholder: "Enter Reference No.",
    type: "text", // Changed to 'text' to handle alphanumeric validation
    required: true,
    gridClass: "col-lg-4",
    validation: {
        required: true,
        maxLength: 20,
        pattern: /^[a-zA-Z0-9]*$/,  // Alphanumeric regex
        message: "Reference No. must be alphanumeric and up to 20 characters",
    },
},

  { 
    name: "ref_date",
    label: "Reference Date",
    type: "date",
    required: true,
    validation:{required:true},
    gridClass: "col-lg-4",
  },

];

  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    
    <div>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
        <div className="backbutton mt-2 mb-2" style={{width:"100%"}} onClick={()=>navigate(ROUTES_NAVIGATION.STOCKTAKING)} >
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add Physical Stock Taking</span>
      </div>


      <div className="btncontainer mt-3 gap-2">
        <button
        onClick={() => {handleFormSubmit(formData)}}className="submit-btn">
        Submit
        </button>
      </div>

      </div>
      <div className="form-container">
     
        <p style={{fontSize:"20px", color:"grey"}}>Please enter stock details</p>
        <DynamicForm
        formConfig={CustomerInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}

          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />

      </div>
      </div>
      )}
    </div>
  )
}

export default CreatePhysicalStockTaking;